<template>
  <div>
    <q-form ref="editForm">
      <c-card :noHeader="true" class="cardClassDetailForm" topClass="topcolor-blue">
        <template slot="card-detail">
          <div class="col-6">
            <c-text
              :editable="param.editables"
              label="취급물질"
              name="inMaterials"
              v-model="item.inMaterials">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              :editable="param.editables"
              label="물질상태"
              name="volume"
              v-model="item.volume">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              :editable="param.editables"
              label="연결구정보"
              name="calculateThick"
              v-model="item.calculateThick">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              suffix="MPa"
              :editable="param.editables"
              label="압력(MPa)-설계"
              name="pressDesign"
              v-model="item.pressDesign">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              suffix="MPa"
              :editable="param.editables"
              label="압력(MPa)-운전"
              name="pressOperation"
              v-model="item.pressOperation">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              suffix="℃"
              :editable="param.editables"
              label="온도(℃)-설계"
              name="tempDesign"
              v-model="item.tempDesign">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              suffix="℃"
              :editable="param.editables"
              label="온도(℃)-운전"
              name="tempOperation"
              v-model="item.tempOperation">
            </c-text>
          </div>
        </template>
      </c-card>
      <c-card :noHeader="true" class="cardClassDetailForm" topClass="topcolor-blue">
        <template slot="card-detail">
          <div class="col-3">
            <c-text
              suffix="㎥"
              :editable="param.editables"
              label="용량(㎥)-설계"
              name="nondestructPercent"
              v-model="item.nondestructPercent">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              suffix="㎥"
              :editable="param.editables"
              label="용량(㎥)-운전"
              name="corrosionAllowance"
              v-model="item.corrosionAllowance">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              :editable="param.editables"
              label="사용재질"
              name="materialMain"
              v-model="item.materialMain">
            </c-text>
          </div>
          <div class="col-3">
            <c-text
              :editable="param.editables"
              label="설계표준"
              name="weldingEfficiency"
              v-model="item.weldingEfficiency">
            </c-text>
          </div>
          <div class="col-12">
            <c-text
              :editable="param.editables"
              label="비고"
              name="applicableLaws"
              v-model="item.applicableLaws">
            </c-text>
          </div>
        </template>
      </c-card>
    </q-form>
  </div>
</template>

<script>
export default {
  name: 'device-machine-detail',
  props: {
    param: {
      type: Object,
      default: () => ({
        psiDeviceEquipmentId: '',
        devicePartCd: '',
        devicePartName: '',
        editables: '',
      }),
    },
    item: {
      type: Object,
      default: () => ({
        psiDeviceEquipmentId: '',  // 장치일련번호
        devicePartCd: '',  // 장치구분
        inMaterials: '',  // 내용물
        volume: '',  // 용량
        pressOperation: '',  // 압력(Mpa)-운전
        pressDesign: '',  // 압력(Mpa)-설계
        tempOperation: '',  // 온도(℃)-운전
        tempDesign: '',  // 온도(℃)-설계
        materialMain: '',  // 사용재질-본체
        materialSubPart: '',  // 사용재질-부속품
        materialGasket: '',  // 사용재질-개스킷
        weldingEfficiency: '',  // 용접효율
        calculateThick: '',  // 계산두께(mm)
        corrosionAllowance: '',  // 부식여유(mm)
        useThick: '',  // 사용두께(mm)
        afterHeatTreatYn: 'N',  // 후열처리여부
        nondestructMethod: '',  // 비파괴검사방법
        nondestructPercent: '',  // 비파괴검사율(%)
        applicableLaws: '',  // 적용법령
      }),
    },
  },
  data() {
    return {
      editable: false,
      afterHeatTreatYnItems: [
        { code: 'Y', codeName: 'Y' },
        { code: 'N', codeName: 'N' },
      ],
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  watch: {
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.item.psiDeviceEquipmentId = this.param.psiDeviceEquipmentId;
      this.item.devicePartCd = this.param.devicePartCd;
      this.item.regUserId = this.$store.getters.user.userId;
      this.item.chgUserId = this.$store.getters.user.userId;
    },
  }
};
</script>
